import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./registerExtension.css";

export const RegisterExtension = () => {
  const secret_key = "6LfkXSElAAAAAA0oAkMb9ZHeQte2vD6iHDJlhq_C";
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  const captcha = useRef(null);

  const onChange = (value) => {
    setRecaptchaValue(value);
    if (captcha.current.getValue()) {
      console.log("El usuario no es un robot");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!recaptchaValue) {
      alert("Debes verificar que no eres un robot");
      return;
    }

    if (inputValue === "") {
      alert("Ingresa un dato");
      return;
    }
    // Recordamos desde que diseno se hizo la consulta para poder volver
    // aqui si ocurre un error en la pantalla de certificados.
    sessionStorage.setItem("registerOrigin", "/extension");
    window.location.href = "/certificados/" + inputValue;
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <div className="container register-extension">
      <div className="row align-items-center">
        {/* Sección izquierda con la descripción */}
        <div className="col-md-7">
          <div className="info-left">
            <div className="top-line"></div>
            <h2 className="mb-3 font-metropolis tittle">
              Descarga tu certificado
            </h2>
            <p className="font-roboto text">
              Verifica y descarga fácilmente tu certificado de cursos,
              diplomados y actividades académicas completadas en Extensión
              Académica.
            </p>

            <div className="feature feature-verde">
              <img
                src="/vpn_lock_2.svg"
                alt=""
                className="feature-icon"
              />
              <span>Certificados con firma digital </span>
            </div>

            <div className="feature feature-morado">
              <img
                src="/assignment.svg"
                alt=""
                className="feature-icon"
              />
              <span>Válidos para cursos, diplomados y actividades de extensión</span>
            </div>

            <div className="feature feature-azul">
              <img src="/bolt.svg" alt="" className="feature-icon" />
              <span>Descarga inmediata en formato PDF de alta resolución</span>
            </div>

            <div className="feature feature-aviso">
              <img src="/Icon.svg" alt="" className="feature-icon" />
              <span>
                ¿Inconvenientes o dudas? Escríbenos a{" "}
                <a href="mailto:contacto@iudigital.edu.co">
                  contacto@iudigital.edu.co
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Sección derecha con el formulario */}
        <div className="col-md-5">
          <div className="p-4 rounded input-document">
            <h3 className="mb-2 text-center font-metropolis">
              Consulta certificado
            </h3>
            <p className="text-center font-roboto sub-text">
              Ingresa tu número de documento y descarga tu certificado.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  className="form-control"
                  id="identificacion"
                  type="text"
                  placeholder="Número de documento"
                  value={inputValue}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3 ReCAPTCHA">
                <ReCAPTCHA
                  ref={captcha}
                  sitekey={secret_key}
                  onChange={onChange}
                />
              </div>
              <div className="button-container font-metropolis d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-danger w-30 text-center"
                >
                  CONSULTA AHORA
                </button>
              </div>
              <p className="text-center font-roboto pie-text">
                Solo disponible para participantes de programas de Extensión
                Académica IU Digital
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
